import { getComponentName } from '../../../helpers/componentHelpers';
import { GridTextColumnClass } from './GridTextColumnClass';

export const componentName = getComponentName('grid-text-column');

customElements.define(componentName, GridTextColumnClass);
